import { useState } from 'react';
import ProfileCard from '../member/shared/ProfileCard';
import MyAdsList from '../member/shared/MyAdsList';
import MemberAnalyticsSection from '../member/analytics/MemberAnalyticsSection';
import PasswordChangeForm from '../member/shared/PasswordChangeForm';
import EmailBindingForm from '../member/shared/EmailBindingForm';
import LineLinkingSection from '../member/shared/LineLinkingSection';
import NotificationPreferences from '../member/shared/NotificationPreferences';
import LogoutButton from '../member/shared/LogoutButton';
import { useShouldHideForLiff } from '../../hooks/useLiffDetection';
import styles from './MobileMemberDashboard.module.css';

// Collapsible Password Change Section
const PasswordChangeSection = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={styles.collapsibleSection}>
      <button
        className={styles.collapsibleHeader}
        onClick={() => setIsExpanded(!isExpanded)}
        aria-expanded={isExpanded}
      >
        <span className={styles.collapsibleTitle}>密碼變更</span>
        <span className={`${styles.collapsibleIcon} ${isExpanded ? styles.expanded : ''}`}>
          ▼
        </span>
      </button>
      {isExpanded && <PasswordChangeForm />}
    </div>
  );
};

type DashboardTab = 'overview' | 'analytics' | 'settings';

const MobileMemberDashboard = () => {
  const [activeTab, setActiveTab] = useState<DashboardTab>('overview');
  const shouldHideLogoutButton = useShouldHideForLiff();

  return (
    <div className={styles.container}>
      {/* Tab Navigation */}
      <div className={styles.tabs}>
        <button
          className={`${styles.tab} ${activeTab === 'overview' ? styles.tabActive : ''}`}
          onClick={() => setActiveTab('overview')}
        >
          概覽
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'analytics' ? styles.tabActive : ''}`}
          onClick={() => setActiveTab('analytics')}
        >
          數據分析
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'settings' ? styles.tabActive : ''}`}
          onClick={() => setActiveTab('settings')}
        >
          帳號設定
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === 'overview' && (
        <>
          <ProfileCard
            isMobile={true}
            onNavigateToSettings={() => setActiveTab('settings')}
          />
          {/* Logout Button - Hide when in LIFF Browser */}
          {!shouldHideLogoutButton && <LogoutButton />}

          <div className={styles.spacer} />
          <MyAdsList />
        </>
      )}

      {activeTab === 'analytics' && <MemberAnalyticsSection />}

      {activeTab === 'settings' && (
        <div className={styles.settings}>
          <NotificationPreferences />
          <EmailBindingForm />
          <LineLinkingSection />
          <PasswordChangeSection />
        </div>
      )}

    </div>
  );
};

export default MobileMemberDashboard;
